import { Label, Stack } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IEventItem } from '../../../../Models/Event/IEventItem';
import { backendUrl } from '../../../../Services/ConfigureService';
import { OrderButton } from '../OrderButton';
import { PriceInfo } from '../PriceInfo';
import { useMediaQuery } from '../../../../Tools/MediaHook';

interface IEventTileViewProps {
   event: IEventItem
}


const labelStyle = {
    root: {
        padding: 5,
        color: "gray",
        fontSize: 14,
        minWidth: 120,
        justifyContent: 'flex-start',
        textAlign: 'start'
    }
}

const textStyle = {
    root: {
        padding: 5,
        color: "black",
        fontSize: 16,
        maxWidth: 600,
        owerflow: "hidden",
        justifyContent: 'flex-start',
        textAlign :'start'
    }
}

export const EventTileView: React.FunctionComponent<IEventTileViewProps> = (props) => {

    const isPageWide = useMediaQuery('(min-width: 800px)')

    const key = useId(props.event.id.toString());

    const labelStyle = {
        root: {
            padding: isPageWide?5:2,
            color: "gray",
            fontSize: isPageWide?14:12,
            minWidth: 120,
            justifyContent: 'flex-start',
            textAlign: 'start'
            
        }
    }

    const textStyle = {
        root: {
            padding: isPageWide ? 5 : 2,
            color: "black",
            fontSize: isPageWide ? 16 : 14,
            
            owerflow: "hidden",
            justifyContent: 'flex-start',
            textAlign: 'start',
            maxWidth:860,
        }
    }


    return (<Stack horizontalAlign="center" wrap horizontal key={key} style={{ padding: 5, border: '1px silver solid', overflow: 'hidden', marginBottom: 8 }}>
        <Stack>
            <img src={backendUrl() + `api/Event/GetProfileImage/${props.event.id}`} style={{ maxWidth: 200 }} onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "/img/noimageicon.png";
            }} />
        </Stack>
        <Stack grow styles={{ root: {paddingLeft: 10 } }} verticalAlign="start">

            <Stack horizontal verticalAlign="center" horizontalAlign="start">
                <Stack.Item styles={labelStyle}>
                    Název
                </Stack.Item>
                <Stack.Item grow styles={textStyle}>
                    <Label style={{ fontSize:16 }}> 
                        {props.event.name}</Label> 
                </Stack.Item>
            </Stack>
             
            <Stack horizontal verticalAlign="center" horizontalAlign="start">
                    <Stack.Item styles={labelStyle}>
                        Lektor
                    </Stack.Item>
                    <Stack.Item grow styles={textStyle}>
                        {props.event.teacher}
                    </Stack.Item>
            </Stack>

            <Stack horizontal verticalAlign="center" horizontalAlign="start">
                <Stack.Item styles={labelStyle}>
                    Začátek
                </Stack.Item>
                <Stack.Item grow styles={textStyle}>
                    {props.event.dateOfFirstLesson}
                </Stack.Item>
            </Stack>

            <Stack horizontal verticalAlign="center" horizontalAlign="start">
                    <Stack.Item styles={labelStyle}>
                        Den a čas konání
                    </Stack.Item>
                    <Stack.Item grow styles={textStyle}>
                        {props.event.lessonsDayTime}
                    </Stack.Item>
                </Stack>
            <Stack horizontal verticalAlign="center" horizontalAlign="start">
                    <Stack.Item styles={labelStyle}>
                        Místo konání
                    </Stack.Item>
                    <Stack.Item grow styles={textStyle}>
                        {props.event.roomName + ", " + props.event.district}
                    </Stack.Item>
                </Stack>
            <Stack horizontal verticalAlign="center" horizontalAlign="start">
                    <Stack.Item styles={labelStyle}>
                        Věková skupina
                    </Stack.Item>
                    <Stack.Item grow styles={textStyle}>
                        {props.event.ageGroupName}
                    </Stack.Item>
            </Stack>                                

            <Stack horizontal verticalAlign="center" horizontalAlign="stretch">
                <Stack.Item styles={labelStyle} >
                    <span></span>
                </Stack.Item>
                <Stack.Item grow styles={textStyle}>
                    <Stack verticalAlign="start" tokens={{ childrenGap: 10 }} horizontal={isPageWide ? true : false} horizontalAlign={isPageWide ? "end" : "start"}>
                        <PriceInfo event={props.event} />
                        <Stack grow>
                            <OrderButton center={isPageWide ? "end" : "start"} event={props.event} />
                        </Stack>
                    </Stack>
                </Stack.Item>
            </Stack>                                            

        </Stack>
    
    </Stack>)
}
 